import { render, staticRenderFns } from "./socialMobile1_ok.vue?vue&type=template&id=280a78c9&scoped=true"
import script from "./socialMobile1_ok.vue?vue&type=script&lang=js"
export * from "./socialMobile1_ok.vue?vue&type=script&lang=js"
import style0 from "./socialMobile1_ok.vue?vue&type=style&index=0&id=280a78c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a78c9",
  null
  
)

export default component.exports